import styled from 'styled-components';
import { rems } from 'fe-appdir-lib-theme';

const AppCardDetailsLink = styled.div`
  margin: 12px 0 0;
  font-size: ${rems(14)};
  font-weight: bold;
  text-align: center;
`;

AppCardDetailsLink.displayName = 'AppCardDetailsLink';

export { AppCardDetailsLink };
